// extracted by mini-css-extract-plugin
export default {"backLink":"page-title_backLink__efvIL","pageTitle":"page-title_pageTitle__404iC","title":"page-title_title__Y1QV4","crumbs":"page-title_crumbs__10BlE"};